import { Browser, isNullOrUndefined } from '@syncfusion/ej2-base';
import { getRowIndexFromElement, isGroupAdaptive, checkIsVirtual, getVisiblePage } from '../base/util';
import { RowModelGenerator } from '../services/row-model-generator';
import { GroupModelGenerator } from '../services/group-model-generator';
import * as events from '../base/constant';
import * as literals from '../base/string-literals';
/**
 * Content module is used to render grid content
 */
export class VirtualRowModelGenerator {
    constructor(parent) {
        this.cOffsets = {};
        this.cache = {};
        this.rowCache = {};
        this.data = {};
        this.groups = {};
        this.currentInfo = {};
        this.prevInfo = {};
        this.parent = parent;
        this.model = this.parent.pageSettings;
        this.rowModelGenerator = this.parent.allowGrouping ? new GroupModelGenerator(this.parent) : new RowModelGenerator(this.parent);
    }
    columnInfiniteRows(data, e) {
        let result = [];
        if (e.requestType === 'virtualscroll') {
            const rows = this.parent.getRowsObject();
            // eslint-disable-next-line prefer-spread
            result.push.apply(result, this.rowModelGenerator.refreshRows(rows));
            if (this.parent.infiniteScrollSettings.enableCache) {
                const currentRowStartIndex = this.parent.frozenRows && this.parent.pageSettings.currentPage === 1 ? 0
                    : getRowIndexFromElement(this.parent.getContentTable().querySelector('.e-row:not(.e-addedrow)'));
                let newResult = result
                    .slice(currentRowStartIndex, currentRowStartIndex + (this.parent.pageSettings.pageSize * 3));
                if (this.parent.frozenRows && this.parent.pageSettings.currentPage !== 1) {
                    newResult = [...result.slice(0, this.parent.frozenRows), ...newResult];
                }
                result = newResult;
            }
        }
        else {
            // eslint-disable-next-line prefer-spread
            result.push.apply(result, this.rowModelGenerator.generateRows(data, e));
        }
        return result;
    }
    generateRows(data, e) {
        if (this.parent.enableColumnVirtualization && this.parent.enableInfiniteScrolling) {
            return this.columnInfiniteRows(data, e);
        }
        let isManualRefresh = false;
        const info = e.virtualInfo = e.virtualInfo
            || ((e.requestType === 'sorting' || e.requestType === 'delete') && checkIsVirtual(this.parent) && this.prevInfo)
            || this.getData();
        this.prevInfo = info;
        const xAxis = info.sentinelInfo && info.sentinelInfo.axis === 'X';
        const page = !xAxis && info.loadNext && !info.loadSelf ? info.nextInfo.page : info.page;
        let result = [];
        let indexes = this.getBlockIndexes(page);
        const loadedBlocks = [];
        if (this.currentInfo.blockIndexes) {
            indexes = info.blockIndexes = e.virtualInfo.blockIndexes = this.includePrevPage ? this.currentInfo.blockIndexes.slice(1)
                : this.currentInfo.blockIndexes.slice(0, this.currentInfo.blockIndexes.length - 1);
            isManualRefresh = true;
        }
        this.checkAndResetCache(e.requestType);
        if (e.requestType === 'pin-row' || e.requestType === 'unpin-row') {
            this.startIndex = null;
        }
        if (isGroupAdaptive(this.parent) && this.parent.vcRows.length) {
            const dataRows = this.parent.vcRows.filter((row) => row.isDataRow);
            if ((this.parent.isManualRefresh && dataRows.length === data['records'].length) || !this.parent.isManualRefresh) {
                return result = this.parent.vcRows;
            }
        }
        if (this.parent.enableColumnVirtualization) {
            for (let i = 0; i < info.blockIndexes.length; i++) {
                if (this.isBlockAvailable(info.blockIndexes[parseInt(i.toString(), 10)])) {
                    this.cache[info.blockIndexes[parseInt(i.toString(), 10)]] =
                        this.rowModelGenerator.refreshRows(this.cache[info.blockIndexes[parseInt(i.toString(), 10)]]);
                }
            }
        }
        const values = info.blockIndexes;
        for (let i = 0; i < values.length; i++) {
            if (!this.isBlockAvailable(values[parseInt(i.toString(), 10)])) {
                let startIdx = !isNullOrUndefined(this.startIndex) && !isNaN(this.startIndex) ? this.startIndex :
                    this.getStartIndex(values[parseInt(i.toString(), 10)], data);
                startIdx = isGroupAdaptive(this.parent) && !this.parent.vcRows.length && (e.requestType === 'sorting'
                    || e.requestType === 'delete' || e.requestType === 'refresh-aggregate-on-save') ? 0 : startIdx;
                const rows = this.rowModelGenerator.generateRows(data, {
                    virtualInfo: info, startIndex: startIdx
                });
                if (isGroupAdaptive(this.parent) && !this.parent.vcRows.length) {
                    this.recordsCount = data.records.length;
                    this.parent.vRows = rows;
                    this.parent.vcRows = rows;
                    this.parent.notify(events.refreshVirtualMaxPage, {});
                }
                let median;
                const isTreeGrid = 'isTreeGrid';
                if (isGroupAdaptive(this.parent)) {
                    this.getGroupVirtualRecordsByIndex(rows);
                }
                else {
                    if (isManualRefresh) {
                        this.setBlockForManualRefresh(this.cache, indexes, rows);
                    }
                    else if (((e.requestType === 'sorting' || e.requestType === 'delete') || (this.parent[`${isTreeGrid}`] && this.parent.getDataModule().isRemote() && e.requestType === 'refresh')) && checkIsVirtual(this.parent)) {
                        const visiblePage = getVisiblePage(info.blockIndexes);
                        let prevEndIndex = 0;
                        for (let i = 0; i < visiblePage.length; i++) {
                            const indexes = this.getBlockIndexes(visiblePage[parseInt(i.toString(), 10)]);
                            let startIndex = this.model.pageSize * i;
                            let endIndex = startIndex + this.model.pageSize;
                            if (this.parent.allowGrouping && this.parent.groupSettings.columns.length) {
                                const dataRowObject = rows.filter((row) => row.isDataRow)
                                    .slice(startIndex, endIndex);
                                startIndex = prevEndIndex;
                                endIndex = rows.indexOf(dataRowObject[dataRowObject.length - 1]) + 1;
                            }
                            const pageRecord = rows.slice(startIndex, endIndex);
                            const median = ~~Math.max(pageRecord.length, this.model.pageSize) / 2;
                            if (!this.isBlockAvailable(indexes[0])) {
                                this.cache[indexes[0]] = pageRecord.slice(0, median);
                            }
                            if (!this.isBlockAvailable(indexes[1])) {
                                this.cache[indexes[1]] = pageRecord.slice(median);
                            }
                            prevEndIndex = endIndex;
                        }
                    }
                    else {
                        median = ~~Math.max(rows.length, this.model.pageSize) / 2;
                        if (!this.isBlockAvailable(indexes[0])) {
                            this.cache[indexes[0]] = rows.slice(0, median);
                        }
                        if (!this.isBlockAvailable(indexes[1])) {
                            this.cache[indexes[1]] = rows.slice(median);
                        }
                    }
                }
            }
            if (this.parent.groupSettings.columns.length && !xAxis && this.cache[values[parseInt(i.toString(), 10)]] &&
                !this.parent.groupSettings.enableLazyLoading) {
                this.cache[values[parseInt(i.toString(), 10)]] =
                    this.updateGroupRow(this.cache[values[parseInt(i.toString(), 10)]], values[parseInt(i.toString(), 10)]);
            }
            if (!e.renderMovableContent && !e.renderFrozenRightContent && this.cache[values[parseInt(i.toString(), 10)]]) {
                // eslint-disable-next-line prefer-spread
                result.push.apply(result, this.cache[values[parseInt(i.toString(), 10)]]);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const DataRecord = [];
                if (this.parent.enableVirtualization && this.parent.groupSettings.columns.length) {
                    result.forEach((data) => {
                        if (!DataRecord.includes(data)) {
                            DataRecord.push(data);
                        }
                    });
                }
                result = DataRecord.length ? DataRecord : result;
            }
            if (this.isBlockAvailable(values[parseInt(i.toString(), 10)])) {
                loadedBlocks.push(values[parseInt(i.toString(), 10)]);
            }
        }
        if (isGroupAdaptive(this.parent) && this.parent.vcRows.length && e.requestType === 'sorting'
            && e.scrollTop.top !== 0) {
            return result = this.parent.vcRows;
        }
        info.blockIndexes = loadedBlocks;
        const grouping = 'records';
        if (this.parent.allowGrouping && this.parent.groupSettings.columns.length) {
            if (this.parent.groupSettings.enableLazyLoading) {
                result.filter((row) => {
                    if (row.isDataRow) {
                        this.parent.currentViewData[row.index] = row.data;
                    }
                });
            }
            else {
                this.parent.currentViewData[`${grouping}`] = result.map((m) => m.data);
            }
        }
        else {
            this.parent.currentViewData = result.map((m) => m.data);
        }
        if (e.requestType === 'grouping') {
            this.parent.currentViewData[`${grouping}`] = this.parent.currentViewData[`${grouping}`].filter((item, index) => this.parent.currentViewData[`${grouping}`].indexOf(item) === index);
        }
        if (isGroupAdaptive(this.parent) && this.parent.vcRows.length) {
            if (['save', 'delete', 'refresh-aggregate-on-save'].some((value) => { return e.requestType === value; })) {
                return result = this.parent.vcRows;
            }
        }
        return result;
    }
    /**
     *
     * @param {Object} data - Defines row data
     * @returns {Row<Column>} returns row model
     * @hidden
     */
    generatePinnedTopRows(data) {
        return this.rowModelGenerator.generatePinnedTopRows(data);
    }
    setBlockForManualRefresh(cache, blocks, rows) {
        const size = this.model.pageSize / 2;
        if (this.includePrevPage) {
            cache[blocks[0] - 1] = rows.slice(0, size);
            cache[blocks[0]] = rows.slice(size, size * 2);
            cache[blocks[1]] = rows.slice(size * 2, size * 3);
            cache[blocks[2]] = rows.slice(size * 3, size * 4);
        }
        else {
            cache[blocks[0]] = rows.slice(0, size);
            cache[blocks[1]] = rows.slice(size, size * 2);
            cache[blocks[2]] = rows.slice(size * 2, size * 3);
            cache[blocks[2] + 1] = rows.slice(size * 3, size * 4);
        }
    }
    getBlockIndexes(page) {
        return [page + (page - 1), page * 2];
    }
    getPage(block) {
        return block % 2 === 0 ? block / 2 : (block + 1) / 2;
    }
    isBlockAvailable(value) {
        return value in this.cache;
    }
    getData() {
        return {
            page: this.model.currentPage,
            blockIndexes: this.getBlockIndexes(this.model.currentPage),
            direction: 'down',
            columnIndexes: this.parent.getColumnIndexesInView()
        };
    }
    getStartIndex(blk, data, full = true) {
        const page = this.getPage(blk);
        const even = blk % 2 === 0;
        const index = (page - 1) * this.model.pageSize + this.parent.pinnedTopRowModels.length;
        return full || !even ? index : index + ~~(this.model.pageSize / 2);
    }
    getColumnIndexes(content = this.parent.getHeaderContent().querySelector('.' + literals.headerContent)) {
        const indexes = [];
        let sLeft = content.scrollLeft | 0;
        const keys = Object.keys(this.cOffsets);
        const cWidth = content.getBoundingClientRect().width;
        sLeft = Math.min(this.cOffsets[keys.length - 1] - cWidth, sLeft);
        const calWidth = Browser.isDevice ? 2 * cWidth : cWidth / 2;
        const left = sLeft + cWidth + (sLeft === 0 ? calWidth : 0);
        let frzLeftWidth = 0;
        const diffWidth = sLeft - calWidth;
        if (this.parent.isFrozenGrid()) {
            frzLeftWidth = this.parent.leftrightColumnWidth('left');
            if (diffWidth > 0) {
                for (let i = this.parent.getVisibleFrozenLeftCount() - 1; i >= 0; i--) {
                    if (diffWidth <= this.cOffsets[parseInt(i.toString(), 10)]) {
                        frzLeftWidth = frzLeftWidth - this.cOffsets[parseInt(i.toString(), 10)];
                        break;
                    }
                }
            }
            if (this.parent.getFrozenMode() === literals.leftRight) {
                const rightCol = this.parent.getVisibleFrozenRightCount();
                keys.splice((keys.length - 1) - rightCol, rightCol);
            }
        }
        const frozenLeftCount = this.parent.getVisibleFrozenLeftCount();
        keys.some((offset) => {
            const iOffset = Number(offset);
            const offsetVal = this.cOffsets[`${offset}`];
            const border = (diffWidth < 0 && iOffset < frozenLeftCount) || ((diffWidth + frzLeftWidth) <= offsetVal &&
                (left + calWidth) >= offsetVal);
            if (border) {
                indexes.push(iOffset);
            }
            return left + calWidth < offsetVal;
        });
        return indexes;
    }
    checkAndResetCache(action) {
        const actions = ['paging', 'refresh', 'sorting', 'filtering', 'searching', 'grouping', 'ungrouping', 'reorder',
            'save', 'delete', 'refresh-aggregate-on-save', 'pin-row', 'unpin-row'];
        const clear = actions.some((value) => action === value);
        if (clear) {
            this.cache = {};
            this.data = {};
            this.groups = {};
        }
        return clear;
    }
    refreshColOffsets() {
        let col = 0;
        this.cOffsets = {};
        const gLen = this.parent.groupSettings.columns.length;
        const cols = this.parent.getVisibleColumns();
        const cLen = cols.length;
        const isVisible = (column) => column.visible &&
            (!this.parent.groupSettings.showGroupedColumn ? this.parent.groupSettings.columns.indexOf(column.field) < 0 : column.visible);
        const c = this.parent.groupSettings.columns;
        for (let i = 0; i < c.length; i++) {
            this.cOffsets[parseInt(i.toString(), 10)] = (this.cOffsets[i - 1] | 0) + 30;
        }
        // eslint-disable-next-line prefer-spread
        const blocks = Array.apply(null, Array(cLen)).map(() => col++);
        for (let j = 0; j < blocks.length; j++) {
            blocks[parseInt(j.toString(), 10)] = blocks[parseInt(j.toString(), 10)] + gLen;
            this.cOffsets[blocks[parseInt(j.toString(), 10)]] =
                (this.cOffsets[blocks[parseInt(j.toString(), 10)] - 1] | 0) + (isVisible(cols[parseInt(j.toString(), 10)]) ?
                    parseInt(cols[parseInt(j.toString(), 10)].width, 10) : 0);
        }
    }
    updateGroupRow(current, block) {
        const currentFirst = current[0];
        let rows = [];
        const keys = Object.keys(this.cache);
        for (let i = 0; i < keys.length; i++) {
            if (Number(keys[parseInt(i.toString(), 10)]) < block) {
                rows = [...rows, ...this.cache[keys[parseInt(i.toString(), 10)]]];
            }
        }
        if ((currentFirst && currentFirst.isDataRow) || block % 2 === 0) {
            return current;
        }
        return this.iterateGroup(current, rows);
    }
    iterateGroup(current, rows) {
        const currentFirst = current[0];
        let offset = 0;
        if (currentFirst && currentFirst.isDataRow) {
            return current;
        }
        const isPresent = current.some((row) => {
            return rows.some((oRow, index) => {
                const res = oRow && oRow.data.field !== undefined
                    && oRow.data.field === row.data.field &&
                    oRow.data.key === row.data.key;
                if (res) {
                    offset = index;
                }
                return res;
            });
        });
        if (isPresent) {
            current.shift();
            current = this.iterateGroup(current, rows.slice(offset));
        }
        return current;
    }
    getRows() {
        let rows = [];
        const keys = Object.keys(this.cache);
        for (let i = 0; i < keys.length; i++) {
            rows = [...rows, ...this.cache[keys[parseInt(i.toString(), 10)]]];
        }
        return rows;
    }
    generateCells(foreignKeyData) {
        const cells = [];
        const cols = this.parent.columnModel;
        for (let i = 0; i < cols.length; i++) {
            cells.push(this.rowModelGenerator.generateCell(cols[parseInt(i.toString(), 10)], null, null, null, null, foreignKeyData));
        }
        return cells;
    }
    getGroupVirtualRecordsByIndex(rows) {
        const blocks = this.parent.contentModule.getGroupedTotalBlocks();
        const blockSize = this.parent.contentModule.getBlockSize();
        if (Object.keys(this.cache).length === 0) {
            let countGroupRow = 0;
            for (let i = 1; i <= blocks; i++) {
                let count = 0;
                this.cache[parseInt(i.toString(), 10)] = [];
                for (let j = ((i - 1) * blockSize + countGroupRow); j < rows.length; j++) {
                    if (count === blockSize) {
                        break;
                    }
                    this.cache[parseInt(i.toString(), 10)].push(rows[parseInt(j.toString(), 10)]);
                    if (rows[parseInt(j.toString(), 10)].isDataRow) {
                        count++;
                    }
                    countGroupRow++;
                }
                countGroupRow -= count;
            }
        }
    }
}
